import { AppDownloadButton } from '../../utils/app-download-button';

export type CampaignLandingContent = {
  /** Display name shown in the hero, e.g. "OPEN TV" */
  name: string;
  /** Hero headline */
  title: string;
  /** Short promo blurb under the headline */
  description: string;
  /** Optional imported logo asset */
  logo?: string;
};

export function CampaignLanding({ content }: { content: CampaignLandingContent }) {
  return (
    <div className="page-root">
      <div className="relative z-10 max-w-[1200px] mx-auto px-8 py-24 min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center text-center gap-6 max-w-xl">
          {content.logo && (
            <img src={content.logo} alt={content.name} className="h-20 object-contain" />
          )}
          <span className="text-sm uppercase tracking-widest text-[#00d9d9] font-semibold">
            {content.name}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white">{content.title}</h1>
          <p className="text-lg text-white/80">{content.description}</p>
          <div className="w-full max-w-xs mt-2">
            <AppDownloadButton />
          </div>
        </div>
      </div>
    </div>
  );
}
